export default "__VITE_ASSET__C6g7iU4b__"